import { __decorate } from "tslib";
import { E_PackageTag } from '@/apis/service/PackageApi.types';
import { injectable } from 'inversify';
import _, { each, isEmpty, map } from 'lodash';
import { isExpireNowFromNumber } from '@/utils/date';
import { CompanyOrganizationCommonService } from './CompanyOrganizationCommonService';
let CompanyProductListService = class CompanyProductListService extends CompanyOrganizationCommonService {
    historyFixed(history, userCanUseChargetModes) {
        const resPrivilege = [];
        const resOpenAPI = [];
        each(history, h => {
            const durationList = h.company_privilege_contract_duration_vo_list;
            if (isEmpty(durationList)) {
                return;
            }
            const package_vo_list = h.package_vo_list;
            const hasOpenAPI = _.findIndex(package_vo_list, p => p.package_tag === E_PackageTag.OPEN_API) >= 0;
            // 合同号, 去重
            const contractNumbersSet = new Set();
            each(h.company_privilege_contract_vo_list, pv => {
                const contractNumber = pv.contract_number; // 合同号
                const enabled = pv.enabled; // 是一个字段 true  或false  有的没有这个字段
                if (contractNumber && enabled) {
                    contractNumbersSet.add(pv.contract_number); // 将合同号去重
                }
            });
            const contractNumbers = Array.from(contractNumbersSet);
            let expiredNum = 0;
            const durationListEx = map(durationList, d => {
                const expired = isExpireNowFromNumber(d.end_at);
                // 如果 为true  表示过期
                if (expired) {
                    expiredNum += 1; // 计数器加1
                }
                return {
                    ...d,
                    expired,
                };
            });
            // 如果全部过期也不显示
            if (expiredNum === durationListEx.length) {
                return;
            }
            // 判断是否为匿名？
            const isAnonymousPrivilege = this.isAnonymousPrivilege(h);
            // 如果是产品列表
            const item = {
                package_vo_list,
                contractNumbers,
                company_privilege_contract_duration_vo_list: durationListEx,
                isAnonymousPrivilege,
                canAssign: this.canUsePrivilege(h, userCanUseChargetModes),
                company_privilege_id: h.company_privilege_id,
            };
            if (hasOpenAPI) {
                resOpenAPI.push(item);
            }
            else {
                resPrivilege.push(item);
            }
        });
        return {
            privilege: resPrivilege,
            openAPI: resOpenAPI,
        };
    }
    getCompanyPrivilegeManagerData(id) {
        const companyPrivilege = this.getCompanyPrivilege(id);
        const userCanUseChargetModes = this.getCanAssignPackageChargeModes();
        return Promise.all([companyPrivilege, userCanUseChargetModes])
            .then(([companyPrivilege, userCanUseChargetModes]) => {
            return this.historyFixed(companyPrivilege, userCanUseChargetModes);
        });
    }
    getOrderVolumeStats(company_id, params) {
        return this.MiscApi.getOrderVolumeStats(company_id, params);
    }
    /**
     * 提交 分配 表单
     */
    postCompanyPrivilegeAssignation(params) {
        return this.PackageApi.postCompanyPrivilegeAssignation(params);
    }
};
CompanyProductListService = __decorate([
    injectable()
], CompanyProductListService);
export { CompanyProductListService };
